module.exports = __webpack_public_path__ + "static/livingSpaces3-73b73bee9f07a416ae9adfc0212e326c.jpg";